import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ChangeDetectionStrategy,
} from '@angular/core';
import { IScrollInfo } from '../models';

@Component({
    selector: 'app-infinite-scroll',
    templateUrl: './infinite-scroll.component.html',
    styleUrls: ['./infinite-scroll.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfiniteScrollComponent<T> implements OnChanges, AfterViewInit {
    @Input() public scrollInfo: IScrollInfo | null;
    @Input() public scrollableCollection: T[] | null;
    @Output() public increaseNumberOfRenderedItems: EventEmitter<number> = new EventEmitter<number>();
    public isSpinnerVisible = false;
    private currentNumberOfRenderedItems?: number;
    constructor() {}
    public ngAfterViewInit(): void {
        this.setInitialState();
    }
    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.scrollableCollection.firstChange) {
            return;
        }

        this.setInitialState();
    }

    

    public onEndOfScroll(isVisible: boolean): void {
        if (!isVisible || !this.hasInfiniteScroll()) {
            return;
        }
        this.setCurrentNumberOfRenderedItems(
            this.currentNumberOfRenderedItems + this.scrollInfo.renderedNumberOfComponentsIncrement,
        );
    }

    public hasInfiniteScroll() {
        return (
            this.isScrollableCollectionValid() &&
            this.scrollInfo &&
            this.scrollableCollection.length >
                (this.currentNumberOfRenderedItems
                    ? this.currentNumberOfRenderedItems
                    : this.scrollInfo.defaultNumberOfComponentsRendered)
        );
    }

    public setCurrentNumberOfRenderedItems(value: number): void {
        this.currentNumberOfRenderedItems = value;
        this.setIsScrollVisible();
        this.increaseNumberOfRenderedItems.emit(this.currentNumberOfRenderedItems);
    }

    private setIsScrollVisible() {
        if (!this.isScrollableCollectionValid()) {
            this.isSpinnerVisible = false;
        }

        this.isSpinnerVisible = this.scrollableCollection.length > this.currentNumberOfRenderedItems;
    }

    private onInputChanged(): void {
        if (!this.currentNumberOfRenderedItems) {
            this.setCurrentNumberOfRenderedItems(this.scrollInfo.defaultNumberOfComponentsRendered);
            return;
        }

        if (this.currentNumberOfRenderedItems <= this.scrollInfo.defaultNumberOfComponentsRendered) {
            this.setCurrentNumberOfRenderedItems(this.scrollInfo.defaultNumberOfComponentsRendered);
        }
    }

    private isScrollableCollectionValid(): boolean {
        if (this.scrollableCollection && !Array.isArray(this.scrollableCollection)) {
            throw new Error('Not An Array Exception');
        }

        return this.scrollableCollection && this.scrollableCollection.length > 0;
    }
    private setInitialState() {
        if (!this.isScrollableCollectionValid()) {
            this.isSpinnerVisible = false;
            return;
        }

        if (!this.hasInfiniteScroll() && this.isScrollableCollectionValid()) {
            this.setCurrentNumberOfRenderedItems(this.scrollableCollection.length);
            return;
        }

        if (this.hasInfiniteScroll()) {
            this.onInputChanged();
            return;
        }
    }
}
